module.exports = __webpack_public_path__ + "img/text_default.04ab1dfe.png";